module.exports = __webpack_public_path__ + "assets/8dc6dd4cf8d5bf87ae2df5405616ec48.json";